module.exports = __webpack_public_path__ + "exit.png?af3bf715e7279c94b27f4a7fe03f3ce5";


//////////////////
// WEBPACK FOOTER
// ./src/assets/exit.png
// module id = 379
// module chunks = 0